// extracted by mini-css-extract-plugin
module.exports = {"notFound":"PageError_notFound__2rtV7"};